import type { QueryEffectBuilds } from "@skilitics/nautilus-core-designer-data";

import type { DesignerEffect } from "../../types/index.ts";
import type { ResolveEffectBuildables } from "../querying/index.ts";
import { makeEffectCreate } from "./makeEffect.ts";

export const getEffectsCreate =
  (queryEffectBuilds: QueryEffectBuilds, resolveEffectBuildables: ResolveEffectBuildables) =>
  (hostNodeId: number, eventType: string, responseId: number): DesignerEffect[] =>
    queryEffectBuilds({ type: "byResponseId", responseId })
      .map(makeEffectCreate({ buildables: resolveEffectBuildables(hostNodeId, eventType) }))
      .filter((v): v is DesignerEffect => Boolean(v));

export type GetEffects = ReturnType<typeof getEffectsCreate>;
